import type { InfoPageContent } from './infoTypes';

export const privacyContent: InfoPageContent = {
  title: 'Privacy Policy',
  tagline: 'No login, no cloud account, no exchange keys. Your data stays in your browser.',
  lastUpdated: 'August 7, 2026',
  sections: [
    {
      heading: '1 · No accounts, no profiles',
      paragraphs: [
        'Pilum Trade Lab has no account system. We do not ask for your name, email, wallet, or any personally identifying information. There is nothing to sign up for and no profile to build.',
      ],
    },
    {
      heading: '2 · Local storage only',
      paragraphs: [
        'The application stores two things in your own browser: your filter preferences (in localStorage) and your local candidate-history archive (in IndexedDB). Both are written by the browser to your device and are never transmitted to us or to any server we operate.',
      ],
      note: 'Clearing your browser’s site data removes both. Pilum keeps no backup anywhere else.',
    },
    {
      heading: '3 · Public market data requests',
      paragraphs: [
        'To show live prices, candles, funding, and liquidity, the application connects directly to public market-data endpoints of Binance, Bybit, OKX, CoinGecko, and DexScreener. These requests carry only what those public APIs need (such as the symbols you are viewing). They are not “our servers” — no data is relayed through a Pilum backend.',
      ],
    },
    {
      heading: '4 · No tracking or analytics',
      paragraphs: [
        'The application embeds no third-party analytics, advertising, fingerprinting, or cross-site tracking scripts. Opening it does not hand your browsing to a marketing stack.',
      ],
    },
    {
      heading: '5 · Cookies',
      paragraphs: [
        'The application does not set its own tracking cookies. Your browser may apply its own default site storage, and the public data providers we connect to are governed by their own privacy policies.',
      ],
    },
    {
      heading: '6 · What we never collect',
      bullets: [
        'Exchange API keys or private keys — the application cannot and will not ask for them.',
        'Wallet addresses or transaction history.',
        'Personal identity data, email, or location.',
        'Any record of which coins you watch — that history exists only in your browser.',
      ],
    },
    {
      heading: '7 · Data deletion',
      paragraphs: [
        'Because nothing leaves your browser, deletion is fully under your control: clear your browser’s site data for this application, and the local archive and preferences are gone.',
      ],
    },
    {
      heading: '8 · Third-party links and services',
      paragraphs: [
        'The application may surface links or data from independent providers (exchanges, market-data services, projects). Those providers operate under their own privacy policies, and we are not responsible for them.',
      ],
    },
    {
      heading: '9 · Changes to this policy',
      paragraphs: [
        'We may update this Privacy Policy as the application evolves. The “last updated” date at the top of this page reflects the current version. This is a browser-first, no-backend application; nothing in that posture changes without this page being updated.',
      ],
    },
  ],
};
